"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfileOwnerContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _ProfileOwnerModel = require("../models/ProfileOwnerModel");
var stub = function stub() {
  throw new Error('<ProfileOwnerProvider> not found.');
};
var ProfileOwnerContext = _react.default.createContext({
  profileOwner: _ProfileOwnerModel.ProfileOwnerModel.Stub(),
  updateProfileOwner: stub
});
exports.ProfileOwnerContext = ProfileOwnerContext;
ProfileOwnerContext.displayName = 'ProfileOwnerContext';